import Base from "../base";

/** 主因仮説/打ち手コメントマスタ */
export interface BiaggregateCauseMeasure extends Base {
  /** ID */
  id: number;
  /** 指標種類 1:稼働率 2:利用者単価 3:キャンセル率 4:加算取得率 5:人時生産性 6:医療保険比率 7:新規取得人数 8:地域医療連携数 9:地域介護連携数 10:リハビリ割合 11:記録提出工数 12:緊急訪問発生率 */
  metrics_type: number;
  /** 指標レベル 1:レベル1 2:レベル2 3:レベル3 */
  metrics_level: number;
  /** 主因仮説 */
  cause: string;
  /** 打ち手タイトル */
  measures_title: string;
  /** 打ち手 */
  measures: string;
  /** 最終更新管理者ID */
  editor_admin_id: number;
}

/** 主因仮説/打ち手コメントマスタ初期値 */
export const DefaultBiaggregateCauseMeasure = (): BiaggregateCauseMeasure => ({
  id: 0,
  metrics_type: 0,
  metrics_level: 0,
  cause: "",
  measures_title: "",
  measures: "",
  editor_admin_id: 0,
  created_at: "",
  updated_at: "",
  deleted_at: "",
});
